import React from "react";
import { Download, FileText } from "lucide-react";

const getFileName = (url = "") => {
    const segments = url.split("/");
    return segments[segments.length - 1] || "tep-dinh-kem";
};

const ReportAttachmentList = ({ files = [], apiUrl, title = "Tệp đính kèm" }) => {
    if (!files || files.length === 0) return null;

    const handleOpenFile = (file) => {
        if (!file?.url_file) return;
        window.open(`${apiUrl}${file.url_file}`, "_blank", "noopener,noreferrer");
    };

    return (
        <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <FileText className="w-4 h-4" />
                {title} ({files.length})
            </h4>
            <div className="space-y-2">
                {files.map((file) => (
                    <div
                        key={file.id || file.url_file}
                        className="flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2"
                    >
                        <div className="min-w-0 flex items-center gap-3">
                            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-white border border-gray-200">
                                <FileText className="w-4 h-4 text-gray-500" />
                            </div>
                            <div className="min-w-0">
                                <p
                                    className="truncate text-sm font-medium text-gray-900"
                                    title={getFileName(file.url_file)}
                                >
                                    {getFileName(file.url_file)}
                                </p>
                                <p className="text-xs text-gray-500">
                                    {file.dinh_dang_file || "application/octet-stream"}
                                    {file.kich_thuoc_file_mb ? ` • ${file.kich_thuoc_file_mb} MB` : ""}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={() => handleOpenFile(file)}
                            className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                        >
                            <Download className="w-4 h-4" />
                            Tải xuống
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReportAttachmentList;
